/**
 * Hides the countdown days element when:
 * 1. The data-days-hide attribute is present
 * 2. The days value equals "00"
 */
(function() {
  'use strict';

  function initDaysHiding() {
    const daysElement = document.getElementById('countdown-timer__days');
    
    // Exit if element doesn't exist
    if (!daysElement) return;
    
    // Exit if hiding is not enabled via data attribute
    if (!daysElement.hasAttribute('data-days-hide')) return;
    
    // Get the days value span
    const daysValue = daysElement.querySelector('[data-type="days"]');
    
    if (!daysValue) return;
    
    // Function to check days value and toggle visibility
    function checkAndToggleVisibility() {
      const value = daysValue.textContent.trim();
      
      if (value === '00') {
        daysElement.style.display = 'none';
      } else {
        daysElement.style.display = '';
      }
    }
    
    // Initial check
    checkAndToggleVisibility();
    
    // Watch for changes to the days value
    const observer = new MutationObserver(checkAndToggleVisibility);
    
    observer.observe(daysValue, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDaysHiding);
  } else {
    initDaysHiding();
  }
})();